import React, { useState } from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckIcon, ChevronDownIcon } from 'lucide-react';
import { useLang } from '../../lib/i18n/LanguageContext';
import { dictionary } from '../../lib/i18n/dictionary';
export function BusinessModel() {
  const {
    lang
  } = useLang();
  const t = dictionary.model;
  const phases = t.phases[lang];
  const [open, setOpen] = useState<number | null>(0);
  return <section id="model" className="py-24 md:py-32 bg-white" data-id="element-233">
      <div className="max-w-7xl mx-auto px-5 md:px-8" data-id="element-234">
        <SectionHeading eyebrow={t.eyebrow[lang]} title={t.title[lang]} subtitle={t.subtitle[lang]} data-id="element-235" />

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-236">
          {phases.map((p, i) => {
          const isOpen = open === i;
          return <motion.div key={p.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.5,
            delay: i * 0.08
          }} className="relative" data-id="element-237">
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} className={`w-full text-left border rounded-md p-6 h-full transition-colors ${isOpen ? 'border-gold/50 bg-gold/[0.04]' : 'border-slate-200 bg-slate-50/40 hover:border-navy-deep/30'}`} aria-expanded={isOpen} data-id="element-238">
                  <div className="flex items-center justify-between mb-4" data-id="element-239">
                    <span className="font-mono text-[11px] tracking-wider text-gold-deep" data-id="element-240">
                      {t.phase[lang]} 0{i + 1}
                    </span>
                    <span className="font-serif text-2xl text-navy-deep/20" data-id="element-241">
                      0{i + 1}
                    </span>
                  </div>
                  <h3 className="font-serif text-xl text-navy-deep mb-4 leading-tight" data-id="element-242">
                    {p.title}
                  </h3>
                  <AnimatePresence initial={false} data-id="element-243">
                    {isOpen && <motion.ul initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3
                }} className="space-y-2.5 overflow-hidden" data-id="element-244">
                        {p.items.map(it => <li key={it} className="flex items-start gap-2.5 text-[13.5px] text-slate-700" data-id="element-245">
                            <CheckIcon className="w-3.5 h-3.5 text-gold-deep mt-1 shrink-0" data-id="element-246" />
                            <span className="leading-snug" data-id="element-247">{it}</span>
                          </li>)}
                      </motion.ul>}
                  </AnimatePresence>
                  {!isOpen && <div className="flex items-center gap-1.5 text-[12px] text-slate-500" data-id="element-248">
                      <ChevronDownIcon className="w-3.5 h-3.5" data-id="element-249" />
                      <span data-id="element-250">
                        {p.items.length}{' '}
                        {lang === 'es' ? 'detalles' : 'details'}
                      </span>
                    </div>}
                </button>
                {i < phases.length - 1 && <div className="hidden lg:block absolute top-1/2 -right-2 w-4 h-px bg-slate-200" data-id="element-251" />}
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}